import { RangeBox } from '@clef/shared/types';

/**
 * A leaf module on purpose. `labelingState` sits in a cycle back through the redux store
 * (`labelingState -> ../../utils -> media_utils -> labelingState`), so a screen that reaches this
 * helper through it can enter the graph on the wrong side and find `ToolMode` uninitialised -
 * which depends on the module evaluation order of every other import in that screen. Keeping the
 * helper here removes the ordering question rather than answering it per call site.
 */

/** For a canvas that does cover the whole media, starting at the origin. */
export const mediaSizedRangeBox = (canvas: OffscreenCanvas): RangeBox => ({
  xmin: 0,
  ymin: 0,
  xmax: canvas.width - 1,
  ymax: canvas.height - 1,
});
